<template>
    <span>
        <div class="vx-row ml-3 mt-8 mb-4">
            <div class="vx-col-w-full flex">
                <vs-checkbox color="primary" v-model="is_tab_expand" icon-pack="feather" icon="icon-check"
                    class="font-bold">Show tab titles</vs-checkbox>
            </div>
        </div>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
                    :key="isSmallerScreen" :value="active_step">
                    <vs-tab v-if="$canAny(['view-holidays-setting'])" icon-pack="feather" icon="icon-check"
                        :label="is_expand ? 'Holidays' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <holiday-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-staff-leaves'])" icon-pack="feather" icon="icon-moon"
                        :label="is_expand ? 'Manage Leave Settings' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ManageLeaveSettings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-manage-notifications-setting'])" icon-pack="feather" icon="icon-bell"
                        :label="is_expand ? 'Manage Notifications' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <notification-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-manage-reports-setting'])" icon-pack="feather" icon="icon-bar-chart-2"
                        :label="is_expand ? 'Manage Reports' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <charts-settings />
                        </div>
                    </vs-tab>

                    <vs-tab v-if="$canAny(['view-scheduled-task-templates'])" icon-pack="feather"
                        icon="icon-dollar-sign" :label="is_expand ? 'Scheduled Task Templates' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <TaskTemplates />
                        </div>
                    </vs-tab>
                    <vs-tab icon-pack="feather" icon="icon-file"
                        :label="is_expand ? 'Skills & Qualifications' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <SkillsQualificationsHome />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-company-address-setting', 'edit-company-address-setting'])" icon-pack="feather" icon="icon-map-pin"
                        :label="is_expand ? 'Company Addresses' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <CompanyAddressSettings />
                        </div>
                    </vs-tab>
                    <!-- <vs-tab icon-pack="feather" icon="icon-file" :label="is_expand ? 'Document Templates' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <DocumentTemplateSettings />
                        </div>
                    </vs-tab> -->
                </vs-tabs>
            </div>
        </div>
    </span>
</template>
<script>
import NotificationSettings from "@/views/pages/settings/General/NotificationSettings";
import ChartsSettings from "@/views/pages/settings/General/ChartsSettings";
import HolidaySettings from './General/HolidaySettings'
import TaskTemplates from '@/views/pages/settings/General/ScheduledTasks/templates.vue'
import ManageLeaveSettings from '@/views/pages/settings/General/ManageLeaveSettings.vue'
import SkillsQualificationsHome from '@/views/pages/settings/skills-and-qualifications/SkillsQualificationsHome.vue'
import DocumentTemplateSettings from '@/views/pages/settings/General/DocumentTemplateSettings.vue'
import CompanyAddressSettings from '@/views/pages/settings/General/CompanyAddressSettings.vue'

export default {
    name: 'StaffSettings',
    data() {
        return {
            is_expand: true,
            tab_mapping: {
                'holidays': 0,
                'manage_leave_settings': 1,
                'manage_notifications': 2,
                'manage_reports': 3,
                'scheduled_task_templates': 4,
                'skills_qualifications': 5,
                'company_addresses': 6,
                'company_address': 6,
                'company-addresses': 6,
            }
        }
    },
    components: {
        NotificationSettings,
        ChartsSettings,
        HolidaySettings,
        TaskTemplates,
        ManageLeaveSettings,
        SkillsQualificationsHome,
        DocumentTemplateSettings,
        CompanyAddressSettings
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        },
        is_tab_expand: {
            get() { return this.is_expand },
            set(val) { this.is_expand = val }
        },
        active_step() {
            const tabParam = this.$route.query.tab;
            if (!tabParam) return 0;
            const tabValues = tabParam.split(' ');
            for (const tab of tabValues) {
                if (this.tab_mapping[tab] !== undefined) {
                    return this.tab_mapping[tab];
                }
            }
            return 0;
        }
    },
}
</script>
<style lang="">

</style>